import StorySingleColumn from './StorySingleColumn';
import StoryImageLeft from './StoryImageLeft';

const VARIANTS = {
  'story-single-column': StorySingleColumn,
  'story-image-left': StoryImageLeft,
};

export default function StorySection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || StorySingleColumn;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
